import{
	LocalStorageService,
	ApiService
} from '@DavisDigital/davisdigitalfrontend.module';

import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js'

class ShepherdService{
	
	public mobileBreakpoint = 768;
	public useMobile = false;
	public runOnce = true;
	public childTyps: any;
	public tour = new Shepherd.Tour({
								defaultStepOptions: {
		  							keyboardNavigation: true,
		  							exitOnEsc: true,
		    						cancelIcon: {
		    									enabled: true
		    						},
		    						classes: 'custom-davis-tour custom-davis-tour-lesson-edit',
		    						scrollTo: { behavior: 'smooth', block: 'center' }
								},
								useModalOverlay: true
								});

constructor(
	private localStorageService : LocalStorageService,
	private apiService			: ApiService
	){}
	
	public $onInit = () => {
	}
	
	public newLessonEdit = () => {
	//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
		let continueTour = this.setStorageKey("newLessonEdit");
		if(!continueTour){
			return;
		}
		
		if(window.innerWidth < this.mobileBreakpoint){
			this.useMobile = true;
		}
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number }) => {

    		this.tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: this.tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: this.tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: this.tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		if(step.id == 'step02'){
                    			$('.add__module__option').addClass('show').removeClass('ng-hide');
                    		}
                    		if(step.id == 'step09'){
                    			$('.add__module__option').addClass('ng-hide').removeClass('show');
                    		}
                    		resolve();
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
		//NOTE: ids cannot be put in with variable names or they will not register for the function to remove under mobile
		this.apiService.getTypesByParent('helperTextNewLesson'). 
			then( data => {
		 	var elements = ['.add__module a.plus__icon','.shepherd-content-book','.shepherd-content-images','.shepherd-content-text','.shepherd-content-video',
		 	'.shepherd-content-button','.shepherd-content-split-layout','.shepherd-import','.shepherd-save'];
			for( let index = 0; index < data.length; index++){
			if(index==1){
					 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: 'bottom'
							},
						  timeout: 350,
						});
			}else{
			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: 'bottom'
							}
						  
						});
				}
			}
		 this.tour.start();
		 }); 

	}
	
	public existingLessonEdit = (reset=false) => {

	//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
		let continueTour = this.setStorageKey("existingLessonEdit");
		if(!continueTour && !reset){
			return;
		}
		
		this.mobileBreakpoint = 1320;
		
		if(window.innerWidth < this.mobileBreakpoint){
			this.useMobile = true;
		}
		
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number }) => {
    	
    		this.tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: this.tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: this.tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: this.tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    	if (step.id == 'step01'){
							$(".lesson_right").addClass("show");
                    	}
                    	if (step.id == 'step04'){
                    		$(".lesson_right").removeClass("show");
                    	};
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
			//set the total steps manually
		    this.apiService.getTypesByParent('helperTextEditLesson'). 
			then( data => {
		 	var elements = ['#lesson_present','#lesson_share','#lesson_export','#lesson_toc'];
			for( let index = 0; index < data.length; index++){
			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: 'bottom'
							},
						  timeout: 350,
						});
				}
		 this.tour.start();
		 }); 
		    
		   	
			
	//Add timeout to let edit angular elements render
		
	}
	
	//!!------bookSingle not implemented yet.

	public initShepherdPortfolioCreate = () => {
		let continueTour = this.setStorageKey("shepherdPortfolioCreate");
		if(!continueTour){
			return;
		}
	    
		// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-portfolio-create',
                	scrollTo: { behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
		
			this.apiService.getTypesByParent('helperTextNewPortfolio'). 
			then( data => {
		 	var elements = ['.add__module a.plus__icon','.shepherd-content-images','.shepherd-content-text','.shepherd-content-video','.shepherd-content-button'
		 	,'.shepherd-content-book','.shepherd-content-split-layout','.shepherd-import','.shepherd-contact-form','.fa-save'];
			for( let index = 0; index < data.length; index++){
				var positoin='right';
				if(index==5){
					positoin='left';
				}
				if(index==0){
					positoin='top';
					 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index], 
					    	on: positoin
							},
						  timeout: 800,
						});
					
				}else{
					
					 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: positoin
							}
						});
					
				}
			}
		 tour.start();
		 }); 

	}
	
	public initShepherdPortfolioMain = (displayFirstTimeLanding) => {
		
	let continueTour = this.setStorageKey("shepherdPortfolioListing");
		if(!continueTour){
			return;
		}
	    //show help wizard only when on listing page
		if( displayFirstTimeLanding) {
			return;
		}
		//
		let useMobilePosition = false;
		if($(window).innerWidth() < 768){
			useMobilePosition = true;
		}
		// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-portfolio-listing',
                	scrollTo: { behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
	
		// Helper Text PortFilioListing
		this.apiService.getTypesByParent('helperTextPortfolioListing'). 
			then( data => {
		 	var elements = ['#MyPortfolio-tab','#MyStudents-tab','#PortfoliosShared-tab','#MyDistrict-tab','#Featured-tab','.create-portfolio'
		 	,'.create-folder'];
			for( let index = 0; index < data.length; index++){
				if(index==0){
					
					 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index], 
					    	on: useMobilePosition ? 'bottom' : 'right'
							},
						  timeout: 800,
						});
					
				}else{
					
					 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: useMobilePosition ? 'bottom' : 'right'
							}
						});
					
				}
			}
		 tour.start();
		 }); 
	
	}
	
	
	
	public initShepherdImageListing = () => {
	let continueTour = this.setStorageKey("shepherdImageListing");
		if(!continueTour){
			return;
		}
				// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-image-listing',
                	scrollTo: { behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	if(step.id == 'step10'){
                    		$(".fullscreen").first().fadeToggle();
                    	}
                    	setTimeout(function(){
                    		resolve();
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
		//Image lisint helper POP up
		 this.apiService.getTypesByParent('helperTextImagesListing'). 
			then( data => {
		 	var elements = ['#imagesearch-tab','#mycollections-tab','#sharedcollections-tab','#daviscollections-tab','#bookcollections-tab'
		 	,'.image-search','.image-filter','#tooltipCompare','.image-add-collection','.card__tile__anchor','.fullscreen'];
			for( let index = 0; index < data.length; index++){
				var position='top';
				if(index==0 || index==1){
					position='bottom';
				}
				
			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							}
						  
						});
				}
			
			tour.start();
			$(".fullscreen").first().fadeToggle();
		}); 
}
	
	public initShepherdImageDetail = () => {
	let continueTour = this.setStorageKey("imageDetailListing");
		if(!continueTour){
			return;
		}
			// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-image-detail',
                	scrollTo: { behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
this.apiService.getTypesByParent('helperTextImageDetail'). 
			then( data => {
		 	var elements = ['.image--info','.image__collection','.image-fullScreen','.image-download'];
			for( let index = 0; index < data.length; index++){
				var position='top';
				if(index==0){
					position='bottom';
				}

			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							}

						});
				}

			if(this.runOnce == true){
			this.runOnce = false;
			tour.start();
		}
		}); 

	
	}
	
	public initShepherdImageCollection = (selectedtab) => {

	let continueTour = this.setStorageKey("imageCollectionListing");
	
		// if(!continueTour){
		// 	return;
		// }
		
		let appendTab;
		if(selectedtab == 'mycollections'){
			appendTab = 'my';
		} else if (selectedtab == 'sharedcollections'){
			appendTab = 'shared';
		} else if (selectedtab == "daviscollections"){
			appendTab = 'davis';
		}else if (selectedtab == "bookcollections"){
			appendTab = 'book';
		};
					// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-image-collection',
                	scrollTo: { behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
	
		 this.apiService.getTypesByParent('helperTextImageCollection'). 
			then( data => {
		 	var elements = ['.launch-slideshow-btn','.share-collection-btn','.compare-img-wrapper','.remove-img-btn','.reorder-img-btn'];
			for( let index = 0; index < data.length; index++){
				var position='top';
				if(index==0){
					position='bottom';
				}
				
			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							}
						  
						});
				}
			
		tour.start();
		}); 
	
	this.apiService.getTypesByParent('helperTextImageCollection'). 
			then( data => {
		 	var elements = ['.launch-slideshow-btn','.share-collection-btn','.compare-img-wrapper','.remove-img-btn','.reorder-img-btn'];
			for( let index = 0; index < data.length; index++){
				var position='top';
				if(index==0){
					position='bottom';
				}

			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							}

						});
				}

		tour.start();
		}); 
	}
	
	
//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
	private setStorageKey = (action : string ) => {
		
	//	let localStorageKey = action == "new" ? 'lesson_editor_new_tour_completed' : "lesson_editor_tour_completed";
	
		let localStorageKey = action;
		
		Shepherd.on('cancel', () => {
			if(!this.localStorageService.getItem(localStorageKey)){
				this.localStorageService.setItem(localStorageKey, '1');
				console.log(this.localStorageService.getItem(localStorageKey));
			} else if (this.localStorageService.getItem(localStorageKey) == '1') {
				this.localStorageService.setItem(localStorageKey, '2')
			} else if (this.localStorageService.getItem(localStorageKey) == '2'){
				this.localStorageService.setItem(localStorageKey, '3')
			} else if (this.localStorageService.getItem(localStorageKey) == '3'){
				return false;
			}
		});
	    
	    if(this.localStorageService.getItem(localStorageKey)){
			let storageKey = this.localStorageService.getItem(localStorageKey);
			if( storageKey != '1' && storageKey != '2')
	        return false;
	    }
	    
	    Shepherd.on('complete', (context, args) => {
	    	//ignore complete action if done from last step, so user can see it again on reload
	    		this.localStorageService.setItem(localStorageKey, Date.now());
	    });
	
		//return true to continue shepherd init
		return true;
	}	    

	
}

export { ShepherdService }